<template>
  <v-container class="pt-0">
    <div class="reward" v-if="!reward && finished === false">
      <h2 class="rewardTitle">
        <span
          v-text="
            userType == 'challenger' ? '파트너의 선물' : '내가 보내는 선물'
          "
        ></span>
      </h2>
      <v-img width="80px" class="mx-auto mb-5" :src="boxSrc"></v-img>
      <div v-if="hint != undefined" class="rewardHint">
        <span>hint</span>
        {{ hint }}
      </div>
      <div v-else class="rewardHint">
        <span>hint</span>
        힌트가 없습니다.
      </div>
      <div v-if="penalty != undefined && penalty != null" class="penalty">
        <span>penalty</span>
        {{ penalty }}
      </div>
    </div>
    <div class="reward" v-else-if="finished === true && succeed === true">
      <h2 class="rewardTitle">
        <span
          v-text="
            userType == 'challenger' ? '파트너의 선물' : '내가 보내는 선물'
          "
        ></span>
      </h2>
      <v-img class="mx-auto mb-5" :src="rewardImage"></v-img>
      <p>{{ reward }}</p>
    </div>
    <div class="reward" v-else-if="finished === true && succeed === false">
      <div class="contentsNone">
        <p class="mb-2">
          <v-icon>mdi-emoticon-cry-outline</v-icon>
        </p>
        <p class="contentsTitle">아이구야 이런!</p>
        <div class="text-center">도전에 실패했습니다 :(</div>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  name: "Reward",
  data() {
    return {
      hint: undefined,
      reward: undefined,
      rewardImage: undefined,
      penalty: undefined,
      box: [
        require("@/assets/images/home/icon_present.svg"),
        require("@/assets/images/home/icon_present2.svg"),
        require("@/assets/images/home/icon_present3.svg"),
      ],
      boxSrc: undefined,
      finished: undefined,
      userType: undefined
    };
  },
  computed: {
    // userType() {
    //   return this.$store.getters.userType;
    // },
    // challengeId() {
    //   return this.$store.getters.challengeId;
    // },
    // finished() {
    //   return this.$store.getters.finished;
    // },
    // succeed() {
    //   return this.$store.getters.succeed;
    // },
  },
  methods: {
    getReward() {
      // this.$axios
      //   .get("/challenges/" + this.challengeId + "/rewards")
      //   .then((response) => {
      //     this.hint = response.data.hint;
      //     this.penalty = response.data.penalty;
      //     this.reward = response.data.reward;
      //     this.rewardImage = response.data.image;

      //     if (response.data.progress > 80) {
      //       this.boxSrc = this.box[2];
      //     } else if (response.data.progress > 50) {
      //       this.boxSrc = this.box[1];
      //     } else {
      //       this.boxSrc = this.box[0];
      //     }

      //     if (this.penalty === null && this.userType == "helper") {
      //       this.$router.push("/penalty");
      //     }
      //   });
      const localStorageUser = window.localStorage.getItem("pushToken");
      if(localStorageUser === "helpertoken"){
        this.userType = 'helper';
      }else{
        this.userType = 'challenger'
      }
      this.hint = "당신을 위한 힌트입니다.";
      this.penalty = "실패하면 어떤 패널티인지 설명해주는 란입니다.";
      this.reward = false;
      this.rewardImage = require("@/assets/images/home/reward.png");
      this.finished = false;
      if (this.progress > 80) {
          this.boxSrc = this.box[2];
        } else if (this.progress > 50) {
          this.boxSrc = this.box[1];
        } else {
          this.boxSrc = this.box[0];
        }
    }
  },
  async mounted() {
    await this.getReward();
  },
};
</script>
<style lang="scss" scoped>
.reward {
  .rewardTitle {
    margin-bottom: 32px;
    position: relative;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    letter-spacing: -0.5px;

    span {
      width: 100%;
      padding: 10px 20px;
      display: block;
      position: relative;
      z-index: 1;
      background-color: #FFB5CC;

      &::before {
        content: "";
        border-top: 6px solid #DB4775;
        border-left: 8px solid transparent;
        border-right: 8px solid #DB4775;
        border-bottom: 6px solid transparent;
        position: absolute;
        left: 0;
        bottom: -12px;
      }
      &::after {
        content: "";
        border-top: 6px solid #DB4775;
        border-left: 8px solid #DB4775;
        border-right: 8px solid transparent;
        border-bottom: 6px solid transparent;
        position: absolute;
        right: 0;
        bottom: -12px;
      }
    }

    &::before {
      content: "";
      border-top: 22px solid #FF8EB1;
      border-left: 16px solid transparent;
      border-right: 16px solid #FF8EB1;
      border-bottom: 22px solid #FF8EB1;
      position: absolute;
      left: -16px;
      top: 12px;
    }
    &::after {
      content: "";
      border-top: 22px solid #FF8EB1;
      border-left: 16px solid #FF8EB1;
      border-right: 16px solid transparent;
      border-bottom: 22px solid #FF8EB1;
      position: absolute;
      right: -16px;
      top: 12px;
    }
  }
  .rewardHint {
    font-size: 14px;
    text-align: center;

    > span {
      color: #FFB5CC;
    }
  }

  .penalty {
    font-size: 14px;
    text-align: center;

    > span {
      color: red;
    }
  }

  .contentsNone{
    border: 0;
    padding: 40px 0;

    i{
      width: 48px;
      height: 48px;
      color: #ffb5cc;
      font-size: 32px;
      background-color: #ffb5cc;
    }
    .contentsTitle{
      color: #ffb5cc;
    }
  }
}
</style>